export const GET_UNREAD_NOTIFICATIONS = 'GET_UNREAD_NOTIFICATIONS';
export const ACTIVATED_LOADING_UNREAD_NOTIFICATIONS =
  'ACTIVATED_LOADING_UNREAD_NOTIFICATIONS';
export const GET_ALL_NOTIFICATIONS = 'GET_ALL_NOTIFICATIONS';
export const CHANGE_NOTIFICATION_READ_STATUS =
  'CHANGE_NOTIFICATION_READ_STATUS';
export const CHANGE_ALL_NOTIFICATIONS_READ_STATUS =
  'CHANGE_ALL_NOTIFICATIONS_READ_STATUS';
